import React from 'react';
import SignedInNavbarImproved from '../../SignedInNavbarImproved';
import { BiArrowBack } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import Container from '../my_container/Container';
import rulesImageOne from '../../../assets/rulesImageOne.png';
import rulesImageTwo from '../../../assets/rulesImageTwo.png';
import rulesImageThree from '../../../assets/rulesImageThree.png';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { motion } from 'framer-motion'; // Import Framer Motion
import { IoCheckmark } from 'react-icons/io5';
import { GoDotFill } from 'react-icons/go';

const RequestStatusPage = () => {
  const navigate = useNavigate();

  const returnsRules = [
    { Image: rulesImageOne, description: 'You have 3-7 days after delivery to return items.' },
    { Image: rulesImageTwo, description: 'We only give Item replacements- no store credit or money back.' },
    { Image: rulesImageThree, description: 'We\'ll handle your request within 7 days' },
  ];

  // Animation variants for the progress tracker steps
  const stepVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
    }),
  };

  return (
    <>
      <SignedInNavbarImproved />
      <div className="min-h-screen max-w-[1500px] mx-auto bg-gray-50 md:flex gap-8 pl-4 lg:pl-8">
        {/* Left Column */}
        <div className="w-full mb-40">
          <div className="pt-6 mb-6">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 sm:space-x-4">
                <div onClick={() => navigate(-1)} className="rounded-full p-1 hover:bg-gray-200">
                  <BiArrowBack className="h-6 w-6 cursor-pointer text-gray-600" />
                </div>
                <div className="text-lg font-bold text-gray-700 sm:text-2xl">Return Status</div>
              </div>
              <span className="rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-700">
                In Progress
              </span>
            </div>
          </div>
          <div className="lg:col-span-2 space-y-6">
            {/* Return Info */}
            <div className="p-6">
              <p className="flex flex-col space-y-1 mb-4 text-gray-700">
                <span className="font-semibold text-gray-500 text-sm">Return ID:</span>
                <span className="font-medium text-gray-700">#RET12345</span>
              </p>
              <p className="flex flex-col space-y-1 mb-2 text-gray-700">
                <span className="font-semibold text-gray-500 text-sm">Status:</span>
                <span className="font-medium text-gray-700">Under Review</span>
              </p>
              <p className="flex flex-col space-y-1 mb-2 text-gray-700">
                <span className="font-semibold text-gray-500 text-sm">Date submitted:</span>
                <span className="font-medium text-gray-700">Oct 15, 2024</span>
              </p>
            </div>

            {/* Progress Tracker */}
            <div className="p-6">
              <h2 className="text-lg font-semibold mb-4">Progress Tracker</h2>
              <ol className="relative border-l border-gray-200">
                {/* Step 1 */}
                <motion.li
                  className="mb-10 ml-6"
                  custom={0}
                  initial="hidden"
                  animate="visible"
                  variants={stepVariants}
                >
                  <span className="absolute -left-3 flex items-center justify-center w-6 h-6 rounded-full bg-[#558223]">
                    <IoCheckmark className="w-4 h-4 text-white" />
                  </span>
                  <h3 className="font-semibold text-gray-900">Under Review - We’re reviewing your request</h3>
                  <p className="text-sm text-gray-600">Our team is checking your return details. Usually takes 1–2 days.</p>
                </motion.li>

                {/* Step 2 (active) */}
                <motion.li
                  className="mb-10 ml-6"
                  custom={1}
                  initial="hidden"
                  animate="visible"
                  variants={stepVariants}
                >
                  <span className="absolute -left-3 flex items-center justify-center w-6 h-6 rounded-full bg-[#558223]">
                    <GoDotFill className="w-5 h-5 text-white" />
                  </span>
                  <h3 className="font-semibold text-[#558223]">Return approved – processing now</h3>
                  <p className="text-sm text-[#558223]/80">We’ve approved your return and started processing your replacement.</p>
                </motion.li>

                {/* Step 3 */}
                <motion.li
                  className="mb-10 ml-6"
                  custom={2}
                  initial="hidden"
                  animate="visible"
                  variants={stepVariants}
                >
                  <span className="absolute -left-3 flex items-center justify-center w-6 h-6 rounded-full bg-gray-300" />
                  <h3 className="font-semibold text-gray-900">Replacement Shipped; Your replacement is on the way</h3>
                  <p className="text-sm text-gray-600">Replacement items have been shipped; should arrive in 1–2 days.</p>
                </motion.li>

                {/* Step 4 */}
                <motion.li
                  className="mb-10 ml-6"
                  custom={3}
                  initial="hidden"
                  animate="visible"
                  variants={stepVariants}
                >
                  <span className="absolute -left-3 flex items-center justify-center w-6 h-6 rounded-full bg-gray-300" />
                  <h3 className="font-semibold text-gray-900">Return completed successfully</h3>
                  <p className="text-sm text-gray-600">Thanks for using Grocedy! Completed Oct 22, 2:30 PM.</p>
                </motion.li>

                {/* Step 5 */}
                <motion.li
                  className="ml-6"
                  custom={4}
                  initial="hidden"
                  animate="visible"
                  variants={stepVariants}
                >
                  <span className="absolute -left-3 flex items-center justify-center w-6 h-6 rounded-full bg-gray-300" />
                  <h3 className="font-semibold text-gray-900">Closed</h3>
                  <p className="text-sm text-gray-600">Return request closed (if rejected or no response).</p>
                </motion.li>
              </ol>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="w-full md:w-80 lg:w-96 shrink-0 bg-white p-6 space-y-6">
          {/* Reason & Resolution */}
          <div className="space-y-4">
            <p className='flex flex-col'>
              <span className="font-medium text-sm text-gray-500">Reason Provided for Return:</span>{' '}
              <span className="text-gray-800 font-semibold">Damaged item received</span>
            </p>
            <p className='flex flex-col'>
              <span className="font-medium text-sm text-gray-500">Resolution Requested:</span>{' '}
              <span className="text-gray-800 font-semibold">Item Replacement</span>
            </p>
          </div>

          {/* Items Being Returned */}
          <div>
            <h2 className="text-2xl font-semibold mb-4">Items Being Returned</h2>
            <ul className="space-y-3">
              <li className="flex justify-between">
                <span>Banana (1kg)</span>
                <span className="text-red-600">Damaged</span>
              </li>
              <li className="flex justify-between">
                <span>Item Name</span>
                <span className="text-red-600">Wrong Item</span>
              </li>
              <li className="flex justify-between">
                <span>Item Name</span>
                <span className="text-red-600">Reason for Return</span>
              </li>
              <li className="flex justify-between">
                <span>Item Name</span>
                <span className="text-red-600">Reason for Return</span>
              </li>
            </ul>
          </div>

          {/* Support Button */}
          <div>
            <button
            className="mt-10 w-full rounded-md border-[1px] border-olivine-500 bg-[#F0F7E1] py-2 text-base opacity-75 transition duration-300 hover:opacity-100 hover:ring-[1px] hover:ring-olivine-500"
            >
            <div className="space-x-2 text-center font-semibold text-olivine-600">
                <span>Contact support</span>
            </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestStatusPage;